//* NAVIGATION MODAL *//
// Manages the State of Navigation

import lib from "../js-lib/lib.js";
import toggler from "../js-lib/toggler.js";
import cacher from "../js-lib/cacher.js";

const NavigationModal = {
  load_cache: (state) => {
    // Load Navigation Modal Cache
    state["NavigationModal"] = cacher.retrieve("NavigationModal")
      ? cacher.retrieve("NavigationModal")
      : state.NavigationModal;
  },
  global_scope: (state) => {
    // Show / Hide Modal
    toggler.toggle(
      lib.qsa(".navigation-modal--toggle"),
      state.NavigationModal,
      NavigationModal.render.bind(this, state),
      state.NavigationModal.key
    );
    //toggler.toggle(lib.qsa('.navigation-modal--toggle'), state.NavigationModal, NavigationModal.render.bind(this, state))
  },
  scope: (state) => {},
  render: (state) => {
    // Store Cached Items
    cacher.store("NavigationModal", state.NavigationModal);
  },
};

export { NavigationModal as default };
